import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Box, Typography } from '@mui/material';

interface QRCodeComponentProps {
    value: string;
    style?: React.CSSProperties;
}

const QRCodeComponent: React.FC<QRCodeComponentProps> = ({ value, style }) => {
    // Set a maximum length for the QR code value to prevent 'data to long' error.
    const maxLength = 2953;

    const isValueTooLarge = value.length > maxLength;

    if (isValueTooLarge) {
        return <Typography color="error" variant='h5'>
            Value is too large to display in a QRCode
        </Typography>
    }

    return <QRCodeSVG style={{
        height: 'auto',
        width: '100%',
        padding: 4,
        backgroundColor: "white"
    }} value={value} />;
};

export default QRCodeComponent;
